import axios from 'axios';
import { compressFormDataImages } from './compressImage';

const API = axios.create({
  baseURL: '/api'
});

API.interceptors.request.use(async config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    try {
      config.data = await compressFormDataImages(config.data);
    } catch (error) {
      error.response = { data: { message: error.message || '照片压缩失败' } };
      throw error;
    }
  }
  return config;
});

API.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default API;
